import { Layout } from '@components/common'
import { getConfig } from '@framework/api/config'
import {
  getAllProductsPaths,
  getProduct,
  getRecomendedProducts,
} from '@framework/product'
import {
  GetStaticPaths,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from 'next'
import { ProductView } from '@components/product'

// fetch all of the products slugs
export const getStaticPaths: GetStaticPaths = async () => {
  const config = getConfig()
  const { products } = await getAllProductsPaths(config)

  return {
    paths: products.map((p) => ({ params: { slug: p.slug } })),
    fallback: 'blocking',
  }
}

// provide product speficic data to the page
export const getStaticProps = async ({
  params,
}: GetStaticPropsContext<{ slug: string }>) => {
  const config = getConfig()

  const { product } = await getProduct({
    config,
    variables: { slug: params?.slug },
  })

  if (!product) {
    return {
      notFound: true,
    }
  }

  const recProducts = await getRecomendedProducts({
    config,
    variables: { productId: product?.id },
  })

  return {
    props: {
      product,
      recProducts,
    },
    revalidate: 60 * 5,
  }
}

export default function ProductSlug({
  product,
  recProducts,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return <ProductView product={product} recProducts={recProducts} />
}

ProductSlug.Layout = Layout
